/*
 * Isolated, additive fix: when a color <select> inside the quantity-breaks
 * bundle changes, move the product media gallery to the matching variant image.
 * Does not modify bundle.js, variant-picker.js, media-gallery.js or the section markup.
 * Reuses the theme's own public API: mediaGallery.slideshow.select({ id }, ..., { animate }).
 */
(function () {
  function getImageSrc(img) {
    return img.currentSrc || img.src || img.dataset.src || '';
  }

  function pathnameOf(url) {
    try {
      return new URL(url, window.location.href).pathname;
    } catch (e) {
      return '';
    }
  }

  function findMediaIdForImageUrl(gallery, targetUrl) {
    var targetPath = pathnameOf(targetUrl);
    if (!targetPath) return null;

    var containers = gallery.querySelectorAll('.product-media[data-media-id]');
    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      var img = container.querySelector('img');
      if (!img) continue;

      var src = getImageSrc(img);
      if (!src) continue;

      if (pathnameOf(src) === targetPath) {
        return container.getAttribute('data-media-id');
      }
    }
    return null;
  }

  function handleChange(event) {
    try {
      var select = event.target;
      if (!select || !select.classList || !select.classList.contains('quantity-break__variant-select')) return;

      var mapAttr = select.getAttribute('data-variant-images');
      if (!mapAttr) return;

      var variantImages;
      try {
        variantImages = JSON.parse(mapAttr);
      } catch (e) {
        return;
      }
      if (!variantImages || typeof variantImages !== 'object') return;

      var imageUrl = variantImages[select.value];
      if (!imageUrl) return;

      var scope = select.closest('.shopify-section, dialog');
      if (!scope) return;

      var gallery = scope.querySelector('media-gallery');
      if (!gallery) return;

      var mediaId = findMediaIdForImageUrl(gallery, imageUrl);
      if (!mediaId) return;

      var slideshow = gallery.slideshow;
      if (!slideshow || typeof slideshow.select !== 'function') return;

      slideshow.select({ id: mediaId }, undefined, { animate: true });
    } catch (e) {
      /* Defensive: never let this feature break the page. */
    }
  }

  document.addEventListener('change', handleChange, { capture: true });
})();
